"use client";

import React from "react";
import Image from "next/image";

export function ImgBannerInvite() {
  return (
  <div className="w-full">
    <div className="px-0 mt-0">
      <div className="relative overflow-hidden rounded-none">
        <Image
          width={1920}
          height={600}
          src="/image/imgBannerInvite.webp"
          className="w-full"
          alt="ร่วมช่วยกันรักษ์โลกนี้ แยกขยะด้วยเครื่องรับคืนขวด"
          style={{ objectFit: "contain" }}
          priority 
          fetchPriority="low" 
        />
      </div>
    </div>
  </div>
  );
}

export default ImgBannerInvite;